// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-container-FwTfR {
  padding: 8px 12px;
  background-color: var(--color-red-50);
  border: 1px solid var(--color-red-200);
  border-radius: var(--radius-lg);
}

.error-message-ok0wZ {
  color: var(--color-red-700);
  margin-right: auto;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/error/error.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB","sourcesContent":[".container {\n  padding: 8px 12px;\n  background-color: var(--color-red-50);\n  border: 1px solid var(--color-red-200);\n  border-radius: var(--radius-lg);\n}\n\n.message {\n  color: var(--color-red-700);\n  margin-right: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `error-container-FwTfR`,
	"message": `error-message-ok0wZ`
};
export default ___CSS_LOADER_EXPORT___;
